import { ICacheService } from './types';

export class CacheService implements ICacheService {
  private cache: ICacheService;

  constructor(cache: ICacheService) {
    this.cache = cache;
  }

  get<T>(key: string): T | undefined {
    return this.cache.get<T>(key);
  }

  set<T>(key: string, value: T, ttl?: number): void {
    this.cache.set<T>(key, value, ttl);
  }

  delete(key: string): void {
    this.cache.delete(key);
  }

  clear(): void {
    this.cache.clear();
  }

  has(key: string): boolean {
    return this.cache.has(key);
  }

  getStats() {
    return this.cache.getStats?.();
  }
}
